import { render, staticRenderFns } from "./OutsourcingPersonImportDialog.vue?vue&type=template&id=2efa5b4a&scoped=true&"
import script from "./OutsourcingPersonImportDialog.vue?vue&type=script&lang=js&"
export * from "./OutsourcingPersonImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingPersonImportDialog.vue?vue&type=style&index=0&id=2efa5b4a&lang=scss&scoped=true&"
import style1 from "./OutsourcingPersonImportDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa5b4a",
  null
  
)

export default component.exports